<script>
import { getUserMap } from '../../js/utils/map.js';

export const pageName = 'map-assessors-list';
export const pageRoute = '/model-achievement-programme/assessors';
export const title = 'MAP Assessors'
export const requireMembership = true;
export const requireCompleteAccount = true;

import { queries } from '../../js/lib/functions.js';
import { getLevelName } from '../../../functions/domain/map/map.js';
import { certLevelToLevel, rsoLevelToLevel } from '../../../functions/domain/certification-utils.js';
import ukraLogo from '../../img/ukra-logo.png'

export default {
	data() {
		return {
			assessors: [],
			ukraLogo,
			ready: false
		}
	},

	methods: {
		getLevelName,
		certLevelToLevel,
		rsoLevelToLevel,
		async show() {
			let assessors = await queries.map.listAssessors();
			await Promise.all(assessors.map(async ass => {
				ass.userMap = await getUserMap(ass);
			}))
			this.assessors = assessors;
			this.ready = true;
		},
	}
}

</script>
<template>
	<div v-if="ready" class="container py-5">
		<h1 class="display-4 text-center mb-3">MAP Assessors</h1>
		<p class="text-muted text-center">MAP Assessors are volunteers who give up their time to help you with your MAP journey.</p>
		<p class="text-muted text-center">Below is a list of all active MAP Assessors to help you find them at your local club meet.</p>
		<p class="text-muted text-center mb-5">Please speak to your local club to understand who is likely to be present at any particular meet.</p>
			
		
		<div class="row justify-content-center">
			<div class="col col-12 col-lg-8 ">
				<div class="card">
					<div class="card-body">
						<div class="list-group list-group-flush my-n3">
							<div v-for="assessor in assessors" class="list-group-item py-5">
								<div class="row">
									<div class="col-auto">
										<div class="avatar avatar-xl">
											<img class="avatar-img rounded-circle" :src="assessor.avatar">
										</div>
									</div>
									<div class="col">
										<div class="row">
											<div class="col-12 col-lg">
												<h2 class="mb-1">{{ assessor.name }}</h2>
												<p class="mb-1">{{ getLevelName(assessor.map.level) }}</p>
												<p>{{ assessor.map.xp }} XP, {{ assessor.map.hydrazine }} Hydrazine</p>
											</div>
											<div class="col-12 col-lg-auto">
												<span v-if="assessor.ukra.role" class="badge badge-lg badge-ds m-2"><img :src="ukraLogo" alt="UKRA Logo" /> {{ assessor.ukra.role }}</span>
												<span v-if="assessor.certification.level" class="badge badge-lg badge-ds m-2"><span class="fe fe-award"></span> HPR {{ certLevelToLevel(assessor.certification.level) }}</span>
												<span v-if="assessor.rso.level" class="badge badge-lg badge-ds m-2"><span class="fe fe-shield"></span> {{ rsoLevelToLevel(assessor.rso.level) }} RSO</span>
											</div>
										</div>
										
										<div class="pl-4">
											<a v-for="task of assessor.userMap.completedTasks":href="`/model-achievement-programme/task/${encodeURIComponent(task.id)}`" class="d-inline-block ml-n4 hover-z" :aria-title="task.name" :style="`background: url(${task.bg}); background-size: contain; width: 53px; height: 56px;`">
												<img :src="task.icon" style="width: 53px; height: 56px;" />
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
